<template>
  <b-row>
    <b-col>
      OAuth2 Connection Failed
      <p>
        <label>Error Code:</label>{{ errorCode }}
      </p>
      <p>
        <label>Error Text:</label>{{ errorText }}
      </p>
      <square-payments-oauth2-service-connected />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'square-payments-oauth2-connect-failure',
  prop: {
    errorCode: {
      type: String,
      required: false
    },
    errorText: {
      type: String,
      required: false
    }
  },
  computed: {
    isConnected: function() {
      return this.$store.getters['square/isConnected']
    }
  },
  created: function() {
    this.$store.dispatch('square/getIsConnected')
  }
}
</script>

<style lang="scss" scoped>

</style>
